import * as React from 'react';

import { compose } from 'recompose';

import Retracked from 'js/app/retracked';

import { previewShouldShowCourseraPlusMerchandisingPlacements } from 'bundles/coursera-plus/utils/subscriptionsForwardDiscoveryExperiment';
import ConsumerPathwayRolePageRootContent from 'bundles/unified-career-academy/pages/consumer/role-page/ConsumerPathwayRolePageRootContent';
import ConsumerRolePageRootContent from 'bundles/unified-career-academy/pages/consumer/role-page/ConsumerRolePageRootContent';
import ConsumerPathwayRolePageDataProvider from 'bundles/unified-career-academy/providers/ConsumerPathwayRoleDataProvider';
import ConsumereRolePageDataProvider from 'bundles/unified-career-academy/providers/ConsumerRolePageDataProvider';
import CourseraPlusUpsellPlacementDataProvider from 'bundles/unified-common/providers/CourseraPlusUpsellPlacementDataProvider';
import { showPathwaysCareerAcademyPages } from 'bundles/unified-common/utils/showPathways';

const PathwaysRolePageWrapper = () => {
  const showUpsells = previewShouldShowCourseraPlusMerchandisingPlacements();

  return (
    <ConsumerPathwayRolePageDataProvider>
      <CourseraPlusUpsellPlacementDataProvider location="RDP" skipQuery={!showUpsells}>
        <ConsumerPathwayRolePageRootContent />
      </CourseraPlusUpsellPlacementDataProvider>
    </ConsumerPathwayRolePageDataProvider>
  );
};

const ConsumerRolePageRootWrapper = () => {
  if (showPathwaysCareerAcademyPages()) {
    return <PathwaysRolePageWrapper />;
  }

  return (
    <ConsumereRolePageDataProvider>
      <ConsumerRolePageRootContent />
    </ConsumereRolePageDataProvider>
  );
};

export default compose(
  Retracked.createTrackedContainer(() => ({
    namespace: {
      app: 'unified_career_academy',
      page: 'consumer_career_academy_role_page',
    },
  }))
)(ConsumerRolePageRootWrapper);
